import(/* webpackMode: "eager", webpackExports: ["PageSingle"] */ "/vercel/path0/src/components/single/page.tsx");
